import { ActionResponse } from '~/types/app'
import { PortalSettingsFormData } from '~/types/portal'
import { ValidationMessage } from '~/types/product'

export enum PreviewMode {
  LANDING_PAGE = 'lp',
  PRODUCT = 'product',
  TEMPLATE = 'template',
}

export interface LandingPagePreviewActionData {
  isPreview: boolean;
  previewData?: PortalSettingsFormData;
}

export interface PublishProductActionData {
  published: boolean;
  validationMessage?: ValidationMessage
}

export interface PreviewTemplateActionData {
  published: boolean;
  validationMessage?: ValidationMessage
}

export interface PreviewProductActionData extends ActionResponse, PublishProductActionData { }

export interface SpPortalActionData extends LandingPagePreviewActionData { }